 
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import UserInfo from '../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../shared/utility';
import * as actions from '../../store/actions/index';
import Messages from '../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../shared/Config';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { InputText } from 'primereact/inputtext';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { apcologo } from '../../shared/fontsAndBitImages';
import { fromPairs } from 'lodash';
// import { fontStyle } from 'html2canvas/dist/types/css/property-descriptors/font-style';


const Inputs = ({ field, metaData, onInputChange, ...props }) => {

    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        style={props.style}
        onInputChange={onInputChange}
//        metaData={Object.assign({}, { ...metaData }, { 'Employee': props.employeeData && props.employeeData.length > 0 ? props.employeeData : props.keywordValuesList, 'Business Unit': props.BusinessUnitData, 'Department': props.DepartmentData, 'Section': props.SectionData })}
        // metaData={Object.assign({}, { ...metaData }, {'Employee': props.employeeData && props.employeeData.length > 0 ? props.employeeData : props.emplist, 'Business Unit': props.BusinessUnitData, 'Department': props.DepartmentData, 'Section': props.SectionData })}
        // metaData={Object.assign({}, { ...metaData }, {'Employee': props.filterApplied ? props.filteredEmployeeData : props.emplist, 'Business Unit': props.BusinessUnitData, 'Department': props.DepartmentData, 'Section': props.SectionData })}
           metaData={Object.assign({}, { ...metaData }, {'Employee': props.filterApplied ? props.filteredEmployeeData : (props.employeeData && props.employeeData.length > 0 ? props.employeeData : props.emplist), 'Business Unit': props.BusinessUnitData, 'Department': props.DepartmentData, 'Section': props.SectionData })}

    /> || null;

}

const TIMESHEET_ID = 'b5585767-17f2-43d4-979b-efd191b4c3fa';


class AddTimesheetProcess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            stageSequence: 0,
            requestDate: moment(),
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            BusinessUnitData: [],
            timesheetForm: [
                ['AL', 'Annual Leave', 'SKL', 'Sick Leave', 'CO', 'Compensatory OFF', 'UL', 'Unpaid Leave'],
                ['EL', 'Emergency Leave', 'WI', 'Working Injury Leave', 'EXL', 'Examination Leave', 'ML', 'Marraige Leave'],
                ['CL', 'Child Birth Leave', 'DL', 'Death Leave', 'HL', 'Hajj Leave', 'BT', 'Business Trip'],
                ['TR', 'Training', 'SL', 'Sport Leave', 'G', 'General(7:30am - 4:00pm)', 'M', 'Morning Shift(7:00am - 3:00pm)'],
                ['E', 'Evening Shift(3:00am - 11:00pm)', 'N', 'Night Shift(11pm - 7am)', 'TM', 'Twelve Morning(7:00 am - 7:00 pm)', 'TE', 'Twelve Evening(7:00 pm - 7:00 am)'],
                ['GC', 'General Conir(7:00am - 5:00pm)', 'MC', 'Morning Shift Conir(7:00am - 5:00pm)', 'EC', 'Evening Shift Conir(1:00 pm - 11:00 pm)', 'NC', 'Night Shift Conir(9:00 pm - 7:00 am)'],
                ['SD', 'Security Day(06:00 to 18:00)', 'SN', 'Security Night(18:00 to 06:00)', 'SM', 'Security Morning(1:00 pm - 11:00 pm)', 'NC', 'Night Shift Conir(9:00 pm - 7:00 am)'],
                ['GS', 'General HR(07:30 - 5:30)', 'QD', 'Quality Day(06:00AM - 06:00PM)', 'QN', 'Quality Night(06:00PM - 06:00 AM)', 'S1', 'Shift 1(7:00 am - 1:00 pm)'],
                ['s2', 'Shift 2(01:00pm - 07:00 pm)', 'S3', 'Shift 3(07:00pm - 01:00am)', 'S4', 'Shift 4(01:00am - 07:00 am)', 'OT1', 'OT1'],
                ['Shrt', 'Short Hrs', 'Reg', 'Regular']
            ],
            DepartmentData: [],
            SectionData: [],
            employeeData: [],
            expandedRows: false,
            ProjectData: [],
            VendorData: [],
            CostCenterData: [],
            OrgUnitData: [],
            emplist:[],
            completeempdata:[],
            filteredEmployeeData:[],
            filterApplied: false,
            dynamicTimesheetDsplay: false
        }
        this.initialize = this.initialize.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.downloadPDF = this.downloadPDF.bind(this);
    }


    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value, type, checked } = e.target;

        this.setState({
            process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue: type === 'checkbox' && field.fieldName === name ? checked  : field.fieldName === name && el.fieldType === "3"  ? value.join(',') : field.fieldName === name ? value : field.fieldValue })) }))
        });

    }
    
    getfilteredEmployeeList = () => {
        this.setState({ loading: true });

        setTimeout(() => {
        const { process, completeempdata } = this.state;
        // Gather filter values for all required fields
        const [filters] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => {
            const result = {
                Vendor: '',
                CostCenter: '',
                EmployeeStatus: '',
                EmployeeType: '',
                OrgUnit: '',
                EmployeeSubGroup: '',
                Nationality: ''
            };
            stage.stage_Field && stage.stage_Field.forEach(el => {
                if (el.fieldDescription === 'Vendor') result.Vendor += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Cost Center') result.CostCenter += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Employee Status') result.EmployeeStatus += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Employee Type') result.EmployeeType += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Organization Unit') result.OrgUnit += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Employee Sub Group') result.EmployeeSubGroup += el.fieldValue ? el.fieldValue + ',' : '';
                if (el.fieldDescription === 'Nationality') result.Nationality += el.fieldValue ? el.fieldValue + ',' : '';
            });
            return result;
        });

        // Prepare arrays for each filter
        const ven = (filters && filters.Vendor ? filters.Vendor.split(',').filter(Boolean) : []);
        const cc = (filters && filters.CostCenter ? filters.CostCenter.split(',').filter(Boolean) : []);
        const empStatus = (filters && filters.EmployeeStatus ? filters.EmployeeStatus.split(',').filter(Boolean) : []);
        const empType = (filters && filters.EmployeeType ? filters.EmployeeType.split(',').filter(Boolean) : []);
        const org = (filters && filters.OrgUnit ? filters.OrgUnit.split(',').filter(Boolean) : []);
        const empSubGroup = (filters && filters.EmployeeSubGroup ? filters.EmployeeSubGroup.split(',').filter(Boolean) : []);
        const nationality = (filters && filters.Nationality ? filters.Nationality.split(',').filter(Boolean) : []);

        const employeeTypeMapping = {
            '1': 'Direct Employee',      // Permanent -> Direct Employee
            '2': 'Contractor Employee',  // Contract -> Contractor Employee
            'Permanent': 'Direct Employee',
            'Contract': 'Contractor Employee'
        };
        const mappedEmpType = empType.map(type => employeeTypeMapping[type] || type);


        // console.log('Selected Filter Values:', {
        //     Vendor: ven,
        //     CostCenter: cc,
        //     EmployeeStatus: empStatus,
        //     EmployeeType: mappedEmpType,
        //     OrgUnit: org,
        //     EmployeeSubGroup: empSubGroup,
        //     Nationality: nationality
        // });

        // Filter completeempdata using all filters
        const filtered = completeempdata.filter(emp => {
            return (
                (ven.length === 0 || (emp.vendorId && ven.includes(emp.vendorId))) &&
                (cc.length === 0 || (emp.costcenterid && cc.includes(emp.costcenterid))) &&
                (empStatus.length === 0 || (emp.empStatus && empStatus.includes(emp.empStatus))) &&
                (mappedEmpType.length === 0 || (emp.employeetypeid && mappedEmpType.includes(emp.employeetypeid))) &&
                (org.length === 0 || (emp.orgId && org.includes(emp.orgId))) &&
                (empSubGroup.length === 0 || (emp.empsubgrp && empSubGroup.some(sg => parseInt(sg) === parseInt(emp.empsubgrp)))) &&
                (nationality.length === 0 || (emp.nationality && nationality.includes(emp.nationality)))
            );
        });
        const mappedFiltered = filtered.map(el => Object.assign({}, { ...el }, { EMPLOYEE_NO: el.userNo, EmployeeName: el.employeeName + '-' + el.costcenter, POSITION: el.postiondescription, DEPARTMENT: el.description, EMPLOYEETYPE: null, label: el.employeeName + '-' + el.costcenter, value: el.userNo, id: parseInt(el.userNo) }));
        this.setState({ filteredEmployeeData: mappedFiltered, filterApplied: true, loading: false });
        console.log('Filtered Employees:', mappedFiltered);
    },1000);
}

    //    clearEmployeeFilter = () => {
    //     this.setState({ loading: true });
    //     setTimeout(() => {
    //     this.setState({ filteredEmployeeData: [], filterApplied: false, loading: false });
    //     },1000);
    // }
    clearEmployeeFilter = () => {
    this.setState({ loading: true });
    setTimeout(() => {
        // Clear filtered data and filterApplied flag
        // Also clear the filter field values in process state
        const filterFields = ['Employee', 'Vendor', 'Cost Center', 'Employee Status', 'Employee Type', 'Organization Unit', 'Employee Sub Group', 'Nationality'];
        
        const updatedProcess = this.state.process.map(stage => {
            return Object.assign({}, { ...stage }, {
                stage_Field: stage.stage_Field.map(field => {
                    if (filterFields.includes(field.fieldDescription)) {
                        return Object.assign({}, { ...field }, { fieldValue: '' });
                    }
                    return field;
                })
            });
        });

        this.setState({ 
            filteredEmployeeData: [], 
            filterApplied: false, 
            loading: false,
            process: updatedProcess
        });
    }, 1000);
}

    getEmployeeListOrg = (list) => {
        const { process } = this.state;
        //const [filterList] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => ['Division', 'Business Unit', 'Department', 'Section'].includes(el.fieldDescription) ? Object.assign({}, { key: el.fieldValue ? a.key + el.fieldValue + ',' : a.key }) : a, { key: '' }));
        const [filterListorg] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => ['Organization Unit'].includes(el.fieldDescription) ? Object.assign({}, { key: el.fieldValue ? a.key + el.fieldValue + ',' : a.key }) : a, { key: '' }));
        const [filterListvendor] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => ['Vendor'].includes(el.fieldDescription) ? Object.assign({}, { key: el.fieldValue ? a.key + el.fieldValue + ',' : a.key }) : a, { key: '' }));
        const [filtercostcenter] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => ['Cost Center'].includes(el.fieldDescription) ? Object.assign({}, { key: el.fieldValue ? a.key + el.fieldValue + ',' : a.key }) : a, { key: '' }));
        const [filterListProj] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => ['Project'].includes(el.fieldDescription) ? Object.assign({}, { key: el.fieldValue ? a.key + el.fieldValue + ',' : a.key }) : a, { key: '' }));
      
        const cc = filtercostcenter.key
        .split(',') // Split the string into an array
        .filter(item => item !== '') // Remove empty items (e.g., from trailing commas)
        .map(item => `'${item}'`) // Add single quotes around each number
            .join(','); // Join the array back into a single string
        
            const org = filterListorg.key
            .split(',') // Split the string into an array
            .filter(item => item !== '') // Remove empty items (e.g., from trailing commas)
            .map(item => `'${item}'`) // Add single quotes around each number
            .join(','); // Join the array back into a single string
        
            const ven = filterListvendor.key
            .split(',') // Split the string into an array
            .filter(item => item !== '') // Remove empty items (e.g., from trailing commas)
            .map(item => `'${item}'`) // Add single quotes around each number
            .join(','); // Join the array back into a single string
        
            const proj = filterListProj.key
            .split(',') // Split the string into an array
            .filter(item => item !== '') // Remove empty items (e.g., from trailing commas)
            .map(item => `'${item}'`) // Add single quotes around each number
            .join(','); // Join the array back into a single string
            let Id = {
                CostCenter: cc.replace(/,\s*$/, ""),
                Project: proj.replace(/,\s*$/, ""),
                Vendor: ven.replace(/,\s*$/, ""),
                OrgUnit: org.replace(/,\s*$/, ""),
        };

        // let Id = {
        //         CostCenter: filtercostcenter.key.replace(/,\s*$/, ""),
        //         Project: filterListProj.key.replace(/,\s*$/, ""),
        //         Vendor: filterListvendor.key.replace(/,\s*$/, ""),
        //         OrgUnit: filterListorg.key.replace(/,\s*$/, ""),
        // };
        var dd = JSON.stringify(Id);
        var datas = { Key: dd };

        //let url = '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;
        axios.post(`/master/api/GetEmployeeListForOrg`,JSON.stringify(datas)).then((response) => {


       // axios.post(`/master/api/GetEmployeeListForOrg`, Id).then((response) => {
            if (response.status === 200) {
                if (response.data) {
                    const employeeData = response.data && response.data.length > 0 && response.data.map(el => Object.assign({}, { ...el }, { EMPLOYEE_NO: el.userNo, EmployeeName: el.employeeName+ '-'+el.costcenter, POSITION: el.postiondescription, DEPARTMENT: el.description, EMPLOYEETYPE: null, label: el.employeeName + '-'+el.costcenter, value: el.userNo, id: parseInt(el.userNo) })) || [];
                    this.setState({ employeeData, loading: false });
                }
            }
            else {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
            }
        }).catch(err => {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Something went wrong, Try Again later' });

        })


    }
 

    simulateOnClick() {
        const { process } = this.state;
        const [data] = process && process.length > 0 && process.filter(_ => _.stageSequence === 0).map(stage => stage.stage_Field && stage.stage_Field.length > 0 && stage.stage_Field.reduce((a, el) => el.fieldDescription === 'Employee' ? Object.assign({}, { ...a }, { EmployeeId: el.fieldValue }) : el.fieldDescription === 'From Date' ? Object.assign({}, { ...a }, { FromDate: el.fieldValue }) : el.fieldDescription === 'Project' ? Object.assign({}, { ...a }, { Project: el.fieldValue }) : el.fieldDescription === 'Vendor' ? Object.assign({}, { ...a }, { Vendor: el.fieldValue }) : el.fieldDescription === 'Cost Center' ? Object.assign({}, { ...a }, { CostCenter: el.fieldValue }) : el.fieldDescription === 'Organization Unit' ? Object.assign({}, { ...a }, { OrgUnit: el.fieldValue }) : el.fieldDescription === 'To Date' ? Object.assign({}, { ...a }, { ToDate: el.fieldValue }) : el.fieldDescription === 'Run Time Evaluation' ? Object.assign({}, { ...a }, { Generate: el.fieldValue }) : a, {}));

        this.props.getEmployeeWorkSheetData(data);
    }

    initialize = (process, type) => {
        this.setState({ loading: true });
        const { tableLists, location = {} } = this.props;
        const { state = {} } = location;
        const { stageSequence, requestDate  } = this.state;
        const status = state.editStatus || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pendingWith = location && location.state && location.state.pendingWith;
        const pageType = this.props.match.params.type;

        let count = 1;
        let sequence = 1;
        const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
            const stageField = arraySort(stage.stage_Field, 'fieldSequence');
            return Object.assign({}, { ...stage }, {
                stage_Field: stageField.reduce((a, el) => {
                    const startIndex = el.fieldName.substring(0, 10);
                    if (type === 'add') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                    } else if (type === 'edit') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: ( pendingWith !== null && pageType === 'edit' && parseInt(stageSequence) === 0) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || ( pendingWith !== null && status && status === 'Closed') ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                            el.stage_FieldsList.map((subField, subIndex) => {
                                if (subIndex != 0) {
                                    subField.stage_FieldsListc2.map(c2 => {
                                        a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: ( pendingWith !== null && pageType === 'edit' && parseInt(stageSequence) === 0) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || ( pendingWith !== null && status && status === 'Closed') ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                    })
                                }
                            })
                        }
                    }
                    return a;
                }, [])
            })
        });

        if (InitialValues && InitialValues.length > 0)
            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);

    }

    saveRequest = (submitType) => {
        const { tableLists = {}, containerData, employeeWorkSheetData = {}, keywordValuesList = [],keywordValuesListsup = [] } = this.props;
        const { Table1 = [],Table = [] } = employeeWorkSheetData;
        const { process } = this.state;
        const type = this.props.match.params.type;

        const RequestTimeSheet = (type === 'edit' && tableLists && Object.keys(tableLists).length > 0 && tableLists.requestTimeSheet && tableLists.requestTimeSheet.length > 0) ? tableLists.requestTimeSheet : Table1.map(el => Object.assign({}, { ...el }));

        const timesheetheader = (type === 'edit' && tableLists && Object.keys(tableLists).length > 0 && tableLists.timesheetheader && tableLists.timesheetheader.length > 0) ? tableLists.timesheetheader : Table.map(el => Object.assign({}, { ...el },
            {
                EmployeeNo: el.EMPLOYEE_NO,
                abscentdays: el.AbsentDays,
                offdaysweekends: el.OffDays,
                userdefinedfield1: el.vendorname,
                // vendorname: el.vendorname,
                presentinwe: el.PresentInWe,
                presentinholiday: el.PresentInLH,
                unpaidleave: el.AbsentDaysUL,
                annualleave: el.Vacationdays,
                holidays: el.Holidays,
                othours: el.OTHours,
                sickleave: el.AbsentDaysSL
             }));

        let FromDate = '';
        let ToDate = '';
        let RequestDate = new Date();
        let Comment = '';
        let RequestAttributes = [];
        var tableLists1 = tableLists;
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {
                if (['Division', 'Business Unit', 'Department', 'Section'].includes(el.fieldDescription)) {
                    el.fieldValue = '';
                }

                if (el.fieldDescription === 'From Date') {
                    FromDate = moment(el.fieldValue).format('MM/DD/YYYY');
                } else if (el.fieldDescription === 'To Date') {
                    ToDate = moment(el.fieldValue).format('MM/DD/YYYY');
                } else if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                    Comment = el.fieldValue;
                }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue || '' }));
            })
        });



        let data = {
            FromDate: FromDate,
            ToDate: ToDate,
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: Comment,
            IsActive: true,
            RequestDate: RequestDate,
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: TIMESHEET_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: [],
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum,
            RequestTimeSheet,
            timesheetheader,
            dynamicTimesheetDsplay: false,
            selectedTimesheet: {}
        };


        if (process && process.length > 0 && RequestTimeSheet && RequestTimeSheet.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'TimeSheet';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'TimeSheet';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'TimeSheet';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
               model = 'TimeSheet';
            }




            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };
            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                    })
                                }
                                if(submitType === 'return'){
                                    this.setState({popupType: 'return'});
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                                // if(submitType === 'submit'){
                                //     this.setState({dialogBoxText: "Select Supervisor"})
                                // }
                                // if(submitType === 'return'){
                                //     this.setState({dialogBoxText: "Return To", popupType:'return'})
                                // }
                               // this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {


                                const { requestId } = this.state;
                                //code to geenerate timesheet pdf file in server folder email upload work
                                if (requestId == false) {
                                    if (response.data.reqId != undefined) {
                                        this.setState({ requestId: response.data.reqId });
                                    }
                                    this.generateTimesheet(tableLists1)
                                        .then((generatedPdf) => {
                                            this.uploadGeneratedTS(generatedPdf)
                                                .then(response => {
                                                    this.setState({ loading: false });
                                                    if (response.status == 200) {
                                                        this.growl.show({ severity: 'success', life: 3000, summary: null, detail: 'Work Permit request submitted successfully' });
                                                        setTimeout(() => {
                                                            this.props.history.push('/dashboard')
                                                        }, 2000);
                                                    }
                                                })
                                                .catch(err => {//catch to the submit request api
                                                    this.setState({ loading: false });
                                                    this.growl.show({ severity: 'success', summary: null, life: 3000, detail: 'Work Permit request submitted successfully' });
                                                    this.growl.show({ severity: 'error', summary: null, life: 3000, detail: 'Email Attachment Failed, Please contact administrator' });
                                                    setTimeout(() => {
                                                        this.props.history.push('/dashboard')
                                                    }, 1800);
                                                })
                                        }).catch((err) => {// catch to the workpermit data download api
                                            this.setState({ loading: false });
                                            this.growl.show({ severity: 'success', summary: null, life: 3000, detail: 'Work Permit request submitted successfully' });
                                            this.growl.show({ severity: 'error', summary: null, life: 3000, detail: 'Work Permit generation failed. Please contact administrator.' });
                                            setTimeout(() => {
                                                this.props.history.push('/dashboard')
                                            }, 1800);
                                        })
                                }
                               


                                        this.growl.show({ severity: 'success', summary: null, detail: 'Timesheet request submitted successfully' });


                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Timesheet request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    generateTimesheet= (tableLists) =>{
        return new Promise((resolve, reject) => { //Implementing promise for this function to be used in the "saveRequest" function for uploading pdf before saving request
            const { employeeWorkSheetData = {},  keywordValuesList = [] } = this.props;
          
            const type = this.props.match.params.type;
            const { Table: EmployeeList = [], Table1 = [] } = employeeWorkSheetData;
            const { expandedRows, employeeData = [], RequestNum,requestId } = this.state;
            var Filearray = [];

    
            EmployeeList.forEach((tableLists1) => {
                //  tableLists.forEach((tableLists1, index, array) => {
                var Timesh = Table1.filter((x) => { return x.EmployeeCode == parseInt(tableLists1.EMPLOYEE_NO); });

                
                // const TableViewList = (type === 'edit' && Timesh && Object.keys(Timesh).length > 0 && Timesh && Timesh.length > 0) ? Timesh.map(el => Object.assign({}, {
                //     EarlyInHours: el.earlyInHours,
                //     EarlyOutHours: el.earlyOutHours,
                //     EmpInTime: el.empInTime,
                //     EmpOutTime: el.empOutTime,
                //     EmployeeCode: el.employeeCode,
                //     EmployeeId: el.employeeId,
                //     EmployeeName: el.employeeName,
                //     LateInHours: el.lateInHours,
                //     LateOutHours: el.lateOutHours,
                //     OtendTime: el.otendTime,
                //     Othours: el.othours,
                //     OtstartTime: el.otstartTime,
                //     ReportedBy: el.reportedBy,
                //     RequestId: el.requestId,
                //     ShiftDate: el.shiftDate,
                //     ShiftEndTime: el.shiftEndTime,
                //     ShiftName: el.shiftName,
                //     costCenterNum: el.costCenterNum,
                //     attendanceHours: el.attendanceHours,
                //     ShiftStartTime: el.shiftStartTime,
                //     TimeSheetId: el.timeSheetId,
                //     WorkingHours: el.workingHours,
                //     FirstINDateTime: el.FirstINDateTime,
                //     LastOutDateTime: el.LastOutDateTime
                // })) : Timesh.map(el => Object.assign({}, { ...el }, { EmployeeId: keywordValuesList.filter(_ => _.id === el.EmployeeCode).reduce((a, el) => el.uniqueId, false) }));
               
                
                
           const TableViewList = (type === 'edit' && Table1 && Object.keys(Table1).length > 0 && Table1 && Table1.length > 0) ? Table1.map(el => Object.assign({}, {
               EarlyInHours: el.earlyInHours,
            EarlyOutHours: el.earlyOutHours,
            EmpInTime: el.empInTime,
            EmpOutTime: el.empOutTime,
            EmployeeCode: el.employeeCode,
            EmployeeId: el.employeeId,
            EmployeeName: el.employeeName,
            LateInHours: el.lateInHours,
            LateOutHours: el.lateOutHours,
            OtendTime: el.otendTime,
            Othours: el.othours,
            OtstartTime: el.otstartTime,
            ReportedBy: el.reportedBy,
            RequestId: el.requestId,
            ShiftDate: el.shiftDate,
            ShiftEndTime: el.shiftEndTime,
            ShiftName: el.shiftName,
            costCenterNum: el.costCenterNum,
            attendanceHours: el.attendanceHours,
            ShiftStartTime: el.shiftStartTime,
            TimeSheetId: el.timeSheetId,
            WorkingHours: el.workingHours 
                })) : Table1.map(el => Object.assign({}, { ...el }, { EmployeeId: keywordValuesList.filter(_ => _.id === el.EmployeeCode).reduce((a, el) => el.uniqueId, false) }));
                    
                
                

                
                
                
                
                var singlerecforempid = Timesh.filter(function (obj) {
                    return obj.EmployeeCode == parseInt(tableLists1.EMPLOYEE_NO)
                })[0];
                // commented by abu     const TableEmployeeList = (type === 'edit') ? employeeData.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
    
                
        const Tableheader = (type === 'edit' && tableLists && Object.keys(tableLists).length > 0)? tableLists.timesheetheaders.map(el => Object.assign({}, {
            EMPLOYEE_NO: el.employeeNo,
            EmployeeName: el.employeeName,
            POSITION: el.position,
            DEPARTMENT: el.department,
            EMPLOYEETYPE: el.employeetype,
            Years: el.years,
            email: el.email,
            vendor: el.vendor,
            vendormail: el.vendormail,
            vendorname: el.userdefinedfield1,
            OTHours: el.othours,
            otph: el.otph,
            attendanceHours: el.attendanceHours,
            WorkingHours: el.requestId,
            attendanceHoursold: el.shiftDate,
            LateInHours: el.shiftEndTime,
            EarlyOutHours: el.shiftName,
            LateInEarlyOutTotal: el.costCenterNum,
            Month1: el.month1,
            attendanceHours12: el.sickleave,
            PresentDays: el.presentdays,
            AbsentDays: el.abscentdays,
            OffDays: el.offdaysweekends,
            PresentInWe: el.presentinwe,
            PresentInLH: el.presentinholiday,
            AbsentDaysUL: el.unpaidleave,
            Vacationdays: el.annualleave,
            Holidays: el.holidays,
            AbsentDaysSL:el.sickleave,
        })):EmployeeList;
   


        const TableEmployeeList = (type === 'edit') ? Tableheader.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
                
                
              //  const TableEmployeeList = EmployeeList.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(parseInt(_.EMPLOYEE_NO)));
    var doc = new jsPDF('landscape', 'mm', [1600, 1100]);

            



                TableEmployeeList.map(list => {
                const selEmpData = TableEmployeeList && TableEmployeeList.find(_ => _.EMPLOYEE_NO === list.EMPLOYEE_NO) || {};
                const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years, WorkingHours,attendanceHours,vendorname, OTHours, otph, LateInEarlyOutTotal,PresentDays,AbsentDays,OffDays,PresentInWe,PresentInLH,AbsentDaysUL,Vacationdays,Holidays,AbsentDaysSL } = selEmpData;
                const ViewList = TableViewList && TableViewList.length > 0 && TableViewList.filter(_ => parseInt(_.EmployeeCode) === parseInt(list.EMPLOYEE_NO)) || [];
                    // const selEmpData = TableEmployeeList && TableEmployeeList.find(_ => _.EMPLOYEE_NO === list.EMPLOYEE_NO) || {};
                    // const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years,  WorkingHours,attendanceHours,vendorname, OTHours, otph, LateInEarlyOutTotal } = selEmpData;
                    // const ViewList = TableViewList && TableViewList.length > 0 && TableViewList.filter(_ => parseInt(_.EmployeeId) === parseInt(list.EMPLOYEE_NO) || parseInt(_.EmployeeCode) === parseInt(list.EMPLOYEE_NO)) || [];
                // doc.autoTable({
                //     theme: 'grid',
                //     body: [[{
                //         content: "TIME SHEET APPROVAL FORM",
                //         colSpan: 8,
                //         styles: { halign: 'center', fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],
                //     [{
                //         content: 'AL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Annual Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'SKL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Sick Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'CO',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Compensatory OFF',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'UL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Unpaid Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'EL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Emergency Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'WI',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Working Injury Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'EXL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Examination Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'ML',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Marraige Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'CL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Child Birth Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'DL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Death Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'HL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Hajj Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'BT',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Business Trip',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],


                //     [{
                //         content: 'TR',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Training',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'SL',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Sport Leave',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'G',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'General(7:30am - 4:00pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'M',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Morning Shift(7:00am - 3:00pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'E',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Evening Shift(3:00am - 11:00pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'N',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Night Shift(11pm - 7am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'TM',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Twelve Morning(7:00 am - 7:00 pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'TE',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Twelve Evening(7:00 pm - 7:00 am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'GC',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'General Conir(7:00am - 5:00pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'MC',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Morning Shift Conir(7:00am - 5:00pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'EC',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Evening Shift Conir(1:00 pm - 11:00 pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'NC',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Night Shift Conir(9:00 pm - 7:00 am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'SD',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Security Day(06:00 to 18:00)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'SN',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Security Night(18:00 to 06:00)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'SM',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Security Morning(1:00 pm - 11:00 pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'NC',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Night Shift Conir(9:00 pm - 7:00 am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],

                //     [{
                //         content: 'GS',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'General HR(07:30 - 5:30)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'QD',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Quality Day(06:00AM - 06:00PM)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'QN',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Quality Night(06:00PM - 06:00 AM)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'S1',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Shift 1(7:00 am - 1:00 pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],



                //     [{
                //         content: 'S2',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Shift 2(01:00pm - 07:00 pm)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'S3',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Shift 3(07:00pm - 01:00am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'S4',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Shift 4(01:00am - 07:00 am)',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'OT1',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'OT1',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }],



                //     [{
                //         content: 'Shrt',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Short Hrs',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Reg',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: 'Regular',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: '',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: '',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: '',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     },
                //     {
                //         content: '',
                //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
                //     }]
                //     ]
                // });
                    
                //  const logoImg = `data:image/png;base64,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` ; // Replace with your actual logo
            doc.addImage(apcologo, 'PNG', 10, 10, 40, 20); // x, y, width, height

                doc.autoTable({
                    theme: 'grid',
                    startY: 40,
                    body: [
                        [{ content: "SNo", styles: { halign: 'center', minCellWidth: 15, fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Emp No",colSpan: 2, styles: { halign: 'center', minCellWidth: 12, fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Name", colSpan: 6, styles: { halign: 'center', fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Position", colSpan: 6, styles: { halign: 'center', fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Company", colSpan: 6, styles: { halign: 'center', fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },                           
                        { content: "Department", colSpan: 5, styles: { halign: 'center', fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Employee Type", colSpan: 4, styles: { halign: 'center', minCellWidth: 20, fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Month", colSpan: 2, styles: { halign: 'center', minCellWidth: 20, fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Year", colSpan: 2, styles: { halign: 'center', minCellWidth: 30, fillColor: 'white', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } }],
                        [
                            { content: EMPLOYEE_NO && '1' || '', styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: EMPLOYEE_NO || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: EmployeeName || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: POSITION || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: vendorname || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },

                            { content: DEPARTMENT || '', colSpan: 5, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: EMPLOYEETYPE || '', colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: Month1 || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: Years || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } }
                        ],
                        [
                            { content:  'Present Days:'+PresentDays != null && PresentDays != undefined? 'Present Days:'+PresentDays:'Present Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content:  'Absent Days:'+AbsentDays != null && AbsentDays  != undefined ? 'Absent Days:'+AbsentDays:'Absent Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: 'Week Off Days:'+OffDays != null  && OffDays  != undefined ?'Week Off Days:'+ OffDays:'Week Off Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: 'Present In Weekend:'+PresentInWe != null  && PresentInWe  != undefined ? 'Present In Weekend:'+PresentInWe:'Present In Weekend:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: 'Present In Holiday:'+PresentInLH != null  && PresentInLH  != undefined  ? 'Present In Holiday:'+PresentInLH:'Present In Holiday:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content:  'Unpaid Leave:'+AbsentDaysUL != null  && AbsentDaysUL  != undefined  ? 'Unpaid Leave:'+AbsentDaysUL:'Unpaid Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content:  'Annual Leave:'+Vacationdays != null && Vacationdays  != undefined  ? 'Annual Leave:'+Vacationdays:'Annual Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: 'Holidays:'+Holidays != null  && Holidays  != undefined ?  'Holidays:'+Holidays: 'Holidays:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } },
                            { content: 'Sick Leave:'+AbsentDaysSL != null  && AbsentDaysSL  != undefined ?'Sick Leave:'+ AbsentDaysSL:'Sick Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', fillColor: 'white', textColor: 'black' } }

                        ],
                        [
                            { content: '', colSpan: '2', styles: { fillColor: 'white', lineColor: 'black', halign: 'center' } },
                            ...ViewList.map(el => Object.assign({}, { content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', styles: {cellWidth: '15px', overflow: 'linebreak', fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center'} })),
                            // ...ViewList.map(el => Object.assign({}, { content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', styles: {cellWidth: '15px', overflow: 'linebreak', fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center',fontSize: 6 , textColor: 'black'} })),
                            { content: 'Total', styles: { fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center' , textColor: 'black'} },
                            { content: 'Pre-Approval', styles: { fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center' , textColor: 'black'} },

                        ],
                        [
                            { content: 'Shift', colSpan: '2', styles: { fontStyle: 'bold', fillColor: 'white', textColor: 'black', lineColor: 'black', halign: 'center'} },
                            ...ViewList.map(el => Object.assign({}, { content: el.ShiftName || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 5 , textColor: 'black' } })),
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } }
                        ],
                            [
                                { content: 'Cost Center', colSpan: '2', styles: { fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center'  } },
                                ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center' } })),
                                // ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6 , textColor: 'black' } })),
                                { content:  '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                                { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                                { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } }
                            ],
                            [
                                { content: 'Attendance Hours', colSpan: '2', styles: { fillColor: 'white', fontStyle: 'bold', lineColor: 'black', halign: 'center' , } },
                                ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours && el.attendanceHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center'} })),
                                // ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours && el.attendanceHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6 , textColor: 'black'} })),
                                { content: attendanceHours && parseFloat(attendanceHours).toFixed(2) || '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                                { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                                { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } }
                            ],                         
                        [
                            { content: 'Regular Hours', colSpan: '2', styles: { fontStyle: 'bold', lineColor: 'black', fillColor: 'white', halign: 'center' } },
                            ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center' } })),
                            // ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6, textColor: 'black' } })),
                            { content: WorkingHours || '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } },
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center' } }
                        ],

                        [
                            { content: 'OT', colSpan: '2', styles: { fontStyle: 'bold', fillColor: 'white' , lineColor: 'black', halign: 'center' } },
                            ...ViewList.map(el => Object.assign({}, { content: el.OTHours && el.OTHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center'} })),
                            // ...ViewList.map(el => Object.assign({}, { content: el.OTHours && el.OTHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6 , textColor: 'black'} })),
                            { content: OTHours && parseFloat(OTHours).toFixed(2) || '', styles: { lineColor: 'black', halign: 'center', fillColor: 'white' } },
                            // { content: OTHours && parseFloat(OTHours).toFixed(2) || '', styles: { lineColor: 'black', halign: 'center', fillColor: 'white',fontSize: 6  } },
                            { content: otph && otph != null && otph.toFixed(2) || '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center'} },
                            // { content: otph && otph != null && otph.toFixed(2) || '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6  } },
                            { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center'} }
                            // { content: '', styles: { lineColor: 'black', fillColor: 'white', halign: 'center',fontSize: 6  } }
                        ]
                    ],
                })
            doc.autoTable({
                theme: 'plain',
                body: [
                    [
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '6', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } }
                    ],
                    [
                        { content: '.....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        { content: '.....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '.........................................................', colSpan: '6', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white',fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        { content: '.........................................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                    ],
                    [
                        { content: 'Entered By', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        { content: 'Checked By: Direct Supervisor', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        { content: 'Approved by: HR Department', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                    ],
                    [
                        { content: '...........................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ],
                    [
                        { content: 'Remarks: HR Department role is to confirm all type of leaves are documented & Direct Supervisor rule is to confirm (CO,OT,OC) are documented. Owner: HR Department', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ],
                    [
                        { content: '...........................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ]
                ]
            })
                    doc.addPage();
                })



            
            
            
      
                //assingning variable from response(start)

                
                let pdf = btoa(doc.output());
                //let FileName = tableLists1.EMPLOYEE_NO + '_' + tableLists1.EmployeeName + '_' + tableLists1.Month1 + '_' + tableLists1.Years;
                 let FileName =requestId;                let Folder = 'TimeSheet';
                let Attachment = pdf;
                let MailData = {
                    FileName,
                    Folder,
                    Attachment
                }
                
    
                let dd = JSON.stringify(MailData);
                let generatedPdf = { Key: dd };
                // resolve(JSON.stringify(generatedPdf));
                //uploadGeneratedTS(JSON.stringify(generatedPdf));
                axios.post(`/master/api/Base4ToPDF`, JSON.stringify(generatedPdf))
                    .then((response => {
                        if (response.status = 200);
                        return;
                    })).catch((err) => {
                        reject(err);
                    });
// if multiple file , each file for each employee to be sent, uncomment below two line
                
                //let timesheetempfolder = {requestId: requestId,  employeeid: singlerecforempid.EmployeeId, filepath: tableLists1.EMPLOYEE_NO + '_' + tableLists1.EmployeeName + '_' + tableLists1.Month1 + '_' + tableLists1.Years+'.pdf',email:tableLists1.email,vendor:tableLists1.vendor,vendormail:tableLists1.vendormail } ; // create an object
               // Filearray.push(timesheetempfolder);
             


            })
            //comment cout blwo two line if mutiple file to be sent to each employee
                let timesheetempfolder = {requestId: requestId,  employeeid: '62867995-DF10-4EED-AD62-33F2E468B905', filepath:requestId +'.pdf',email:'timekeeperjubail@apco-coating.com',vendor:null,vendormail:'timekeeperjubail@apco-coating.com' } ; // create an object
               Filearray.push(timesheetempfolder);
            let data = {
                TimeSheetFile: Filearray
            }

            var stringifyData = JSON.stringify(Filearray);
            var datas = { Key: stringifyData };


            //var datas = { Key: data };
            let url = '/master/api/InsertDynamicData?model=TimeSheetFile';
            this.setState({ loading: true });
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    
                })
                .catch(err => {
                    this.setState({ loading: false })
                //    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })



            
            //this.props.processDynamicData('TimesheetFile',data,'/dashboard');
            // call api to update file for mail
        })
    }

    uploadGeneratedTS = (generatedPdf) => {
        return new Promise((resolve, reject) => {
            // axiosRetry(axios, { 
            //     retries: 8,
            //     retryCondition: (error) => {
            //         // if retry condition is not specified, by default idempotent requests are retried
            //         return error;
            //       },
            // });//For retrying 8 times
            axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            .then((response => {
                resolve(response);
            })).catch((err) => {
                reject(err);
            })
        })
    }

    componentDidMount() {
        // const { getContainerData, getEmployeeDivisionData,getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, location = {} } = this.props;
        const { getContainerData,getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, location = {} } = this.props;
        const type = this.props.match.params.type;
        getContainerData(TIMESHEET_ID);//Get Container Data
        getKeywordValues('Employee');//Get Employee Dropdown list
        getMasterKeywordList('Employee');//Get Employee Dropdown list
        getMasterKeywordList('PROJECT');
        getMasterKeywordList('Vendor');
        getMasterKeywordList('EMPLOYEETYPE');
        getMasterKeywordList('employeesubgroup');
        getMasterKeywordList('nationality/keyword');
        getMasterKeywordList('EmployeeStatus');
        getMasterKeywordList('CostCenter');
        getMasterKeywordList('OrgUnit');
        // getEmployeeDivisionData({});
        this.getEmployeeList();

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);
        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || [];
            }

            if (process && process.length > 0 && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000)
                clearTimer();
            }
        }, 300);

    }

    getEmployeeList = () => {
        axios.get('/master/api/GetEmployeeList').then((response) => {
            if (response.status === 200) {
                if (response.data && response.data.length > 0) {

                    const employeeData = response.data.map(el => Object.assign({}, { ...el }, { EMPLOYEE_NO: el.userNo, EmployeeName: el.employeeName, POSITION: el.postiondescription, DEPARTMENT: el.description, EMPLOYEETYPE: null, label: el.employeeName+ '-'+el.costcenter, value: el.userNo, id: parseInt(el.userNo) }))

                    this.setState({ completeempdata: response.data,employeeData, loading: false });
                }
            }
            else {
                this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
            }
        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Something went wrong, Try Again later' });

        })

    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesListsup } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesListsup })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, employeeWorkSheetData:{},requestAttributeData: {}, keywordValuesList: [],keywordValuesListsup:[], subordinatesListData: [] })
    }

    rowExpansionTemplate = (props) => {
        return null;
    }

    downloadPDF = (method) => {
        const { tableLists, employeeWorkSheetData = {}, keywordValuesList = [] } = this.props;
        const type = this.props.match.params.type;
        const { Table: EmployeeList = [], Table1 = [] } = employeeWorkSheetData;
        const { expandedRows, employeeData = [] } = this.state;


   
        const TableViewList = (type === 'edit' && tableLists && Object.keys(tableLists).length > 0 && tableLists.requestTimeSheet && tableLists.requestTimeSheet.length > 0) ? tableLists.requestTimeSheet.map(el => Object.assign({}, {
            EarlyInHours: el.earlyInHours,
            EarlyOutHours: el.earlyOutHours,
            EmpInTime: el.empInTime,
            EmpOutTime: el.empOutTime,
            EmployeeCode: el.employeeCode,
            EmployeeId: el.employeeId,
            EmployeeName: el.employeeName,
            LateInHours: el.lateInHours,
            LateOutHours: el.lateOutHours,
            OtendTime: el.otendTime,
            Othours: el.othours,
            OtstartTime: el.otstartTime,
            ReportedBy: el.reportedBy,
            RequestId: el.requestId,
            ShiftDate: el.shiftDate,
            ShiftEndTime: el.shiftEndTime,
            ShiftName: el.shiftName,
            costCenterNum: el.costCenterNum,
            attendanceHours: el.attendanceHours,
            ShiftStartTime: el.shiftStartTime,
            TimeSheetId: el.timeSheetId,
            WorkingHours: el.workingHours
        })) : Table1.map(el => Object.assign({}, { ...el }, { EmployeeId: keywordValuesList.filter(_ => _.id === el.EmployeeCode).reduce((a, el) => el.uniqueId, false) }));


        const Tableheader = (type === 'edit' && tableLists && Object.keys(tableLists).length > 0)? tableLists.timesheetheaders.map(el => Object.assign({}, {
            EMPLOYEE_NO: el.employeeNo,
            EmployeeName: el.employeeName,
            POSITION: el.position,
            DEPARTMENT: el.department,
            EMPLOYEETYPE: el.employeetype,
            Years: el.years,
            email: el.email,
            vendor: el.vendor,
            vendormail: el.vendormail,
            vendorname: el.userdefinedfield1,
            OTHours: el.othours,
            otph: el.otph,
            attendanceHours: el.attendanceHours,
            WorkingHours: el.requestId,
            attendanceHoursold: el.shiftDate,
            LateInHours: el.shiftEndTime,
            EarlyOutHours: el.shiftName,
            LateInEarlyOutTotal: el.costCenterNum,
            Month1: el.month1,
            attendanceHours12: el.sickleave,
            PresentDays: el.presentdays,
            AbsentDays: el.abscentdays,
            OffDays: el.offdaysweekends,
            PresentInWe: el.presentinwe,
            PresentInLH: el.presentinholiday,
            AbsentDaysUL: el.unpaidleave,
            Vacationdays: el.annualleave,
            Holidays: el.holidays,
            AbsentDaysSL:el.sickleave,
        })):EmployeeList;

      const TableEmployeeList = (type === 'edit') ? Tableheader.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
    //    const TableEmployeeList = (type === 'edit') ? employeeData.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
        if (method && method === 'all') {
            this.setState({ loadding: true });
            var doc = new jsPDF('landscape', 'mm', [1600, 1100]);

            // Add company name and TimeSheet title centered at the top
            const addHeader = () => {
                const pageWidth = doc.internal.pageSize.getWidth();
                const marginTop = 18;
                doc.setFontSize(18);
                doc.setFont('helvetica', 'bold');
                doc.text('Arabian Pipecoating Company Limited', pageWidth / 2, marginTop + 5, { align: 'center' });
                doc.setFontSize(18);
                doc.setFont('helvetica', 'bold');
                doc.text('TimeSheet', pageWidth / 2, marginTop + 18, { align: 'center' });
            };




            TableEmployeeList.map(list => {

                const selEmpData = TableEmployeeList && TableEmployeeList.find(_ => _.EMPLOYEE_NO === list.EMPLOYEE_NO) || {};
                const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE,Month1, Years, WorkingHours,attendanceHours,vendorname, OTHours , otph, LateInEarlyOutTotal,PresentDays,AbsentDays,OffDays,PresentInWe,PresentInLH,AbsentDaysUL,Vacationdays,Holidays,AbsentDaysSL,} = selEmpData;
                const ViewList = TableViewList && TableViewList.length > 0 && TableViewList.filter(_ => parseInt(_.EmployeeId) === parseInt(list.EMPLOYEE_NO) || parseInt(_.EmployeeCode) === parseInt(list.EMPLOYEE_NO)) || [];

                const { process } = this.state;
                    let FROMDATE = '';
                    let TODATE = '';
                    if (process && process.length > 0) {
                        const stage0 = process.find(stage => stage.stageSequence === 0);
                        if (stage0 && stage0.stage_Field) {
                            const fromField = stage0.stage_Field.find(f => f.fieldDescription === 'From Date');
                            const toField = stage0.stage_Field.find(f => f.fieldDescription === 'To Date');
                            FROMDATE = fromField ? moment(fromField.fieldValue).format('MM-DD-YYYY') : '';
                            TODATE = toField ? moment(toField.fieldValue).format('MM-DD-YYYY') : '';
                        }
                    }
             
                
                //to calculate empty cols
                const daysInMonth = ViewList.length; // N
                const totalColumns = 34; // Must match your header?
                const fixedCols = 2 + 1; // 2 for colSpan at start, 1 for 'Total' at end
                const missingCols = totalColumns - (fixedCols + daysInMonth);
                // Implemented logic:
                // Present days = PresentDays - PresentInWe - PresentInLH
                // Week off days = OffDays - PresentInWe
                // Holiday = Holidays - PresentInLH
                const presentDaysCalc = (PresentDays || 0) - (PresentInWe || 0) - (PresentInLH || 0);
                const weekOffDaysCalc = (OffDays || 0) - (PresentInWe || 0);
                const holidaysCalc = (Holidays || 0) - (PresentInLH || 0);
                const totalHolidays = weekOffDaysCalc + holidaysCalc;
                const presentinLHWE = (PresentInWe || 0) + (PresentInLH || 0);
                const absentNodUL = (AbsentDays || 0) + (AbsentDaysUL || 0);
                const totalCalc = [
                    presentDaysCalc,
                    absentNodUL,
                    PresentInWe,
                    PresentInLH,
                    AbsentDaysUL,
                    Vacationdays,
                    totalHolidays,
                    AbsentDaysSL
                ]
                .map(v => Number(v) || 0)
                .reduce((a, b) => a + b, 0);

                const attendanceRows = [
                    { label: 'Present Days', value: presentDaysCalc },
                    { label: 'Present In Holidays', value: presentinLHWE },
                    { label: 'Holidays', value: totalHolidays  },
                    { label: 'Vacation', value: Vacationdays },
                    { label: 'Absent / NOD / Leave without Pay', value: absentNodUL },
                    { label: 'Leave with Pay / Sick Leave', value: AbsentDaysSL },
                    { label: 'Total', value: totalCalc }
                    // { label: 'Week Off Days', value: weekOffDaysCalc },
                    // { label: 'Present In Weekend', value: PresentInWe },
                    // { label: 'Unpaid Leave', value: AbsentDaysUL },
                ]
                .filter(row => row.value != null && row.value != undefined && Number(row.value) > 0) // ✅ Only rows with value > 0
                .map(row => ([
                    { 
                        content: `${row.label}`,

                        styles: { halign: 'left', lineColor: 'black', textColor: 'black', fontStyle: 'bold', lineWidth: { top: 0.1, bottom: 0.1, left: 0.1, right: 0.1 } } 
                    },
                    {
                        content: row.value,
                        styles: { halign: 'right', lineColor: 'black', textColor: 'black', fontStyle: 'bold', lineWidth: { top: 0.1, bottom: 0.1, left: 0.1, right: 0.1 } }
                    }
                ]));

            // doc.autoTable({
            //     theme: 'grid',
            //     body: [[{
            //         content: "TIME SHEET APPROVAL FORM",
            //         colSpan: 8,
            //         styles: { halign: 'center', fillColor: '#A1A1A1', lineColor: 'black', textColor: 'black' }
            //     }],
            //     [{
            //         content: 'AL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Annual Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'SKL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Sick Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'CO',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Compensatory OFF',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'UL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Unpaid Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'EL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Emergency Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WI',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Working Injury Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'EXL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Examination Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'ML',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Marraige Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'CL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Child Birth Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'DL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Death Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'HL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Hajj Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'BT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Business Trip',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],


            //     [{
            //         content: 'TR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Training',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'SL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Sport Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D081-MOR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning (06.00am - 06.00pm)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D081-SECOND-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning Second Shift Saudi(13.30PM - 10.00pm))',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'D081-MOR-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning Saudi (06.00am - 06.00pm)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D083 -GEN',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'General ( 7.30 - 17.00 pm ) - Jubail Site Office',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'N081-NIGHT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Evening(6.00pm - 06.00 am)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'N081-NIGHT-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Evening Saudi(6.00pm - 06.00 am)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'DOFF - MOR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off -Morning Shift',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off-NIGHT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off- Night',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'RD',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Ramadan Day (6:00 AM to 6:00PM)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'RN',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Ramadan Night (6:00 PM to 6:00AM)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'D084',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Day Shift (Saturday - Half Day)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }]
            //     ]
            // });

             const logoImg = `data:image/png;base64,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` ; // Replace with your actual logo
            doc.addImage(apcologo, 'PNG', 10, 10, 40, 20); // x, y, width, height
            addHeader();
                doc.autoTable({
                    theme: 'grid', 
                    startY: 40,
                    styles: { fontSize: 12.5, textColor: 'black'},
                    body: [
                        [{ content: "SNo", colSpan:1, styles: { halign: 'center', minCellWidth: 0 , lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Emp No", colSpan: 3, styles: { halign: 'center', minCellWidth: 0,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Name", colSpan: 6, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Position", colSpan: 5, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Company", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },                           
                        { content: "Department", colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Employee Type", colSpan: 3, styles: { halign: 'center', minCellWidth: 0,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "From Date", colSpan: 2, styles: { halign: 'center', minCellWidth: 12,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "To Date", colSpan: 2, styles: { halign: 'center', minCellWidth: 12,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Month", colSpan: 2, styles: { halign: 'center', minCellWidth: 12, lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Year", colSpan: 2, styles: { halign: 'center', minCellWidth: 12,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } }],

                        // [{ content: "SNo", styles: { halign: 'center', minCellWidth: 15 , lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Emp No", colSpan: 2, styles: { halign: 'center', minCellWidth: 12,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Name", colSpan: 6, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Position", colSpan: 6, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Company", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },                           
                        // { content: "Department", colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Employee Type", colSpan: 4, styles: { halign: 'center', minCellWidth: 20,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Month", colSpan: 2, styles: { halign: 'center', minCellWidth: 20, lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        // { content: "Year", colSpan: 2, styles: { halign: 'center', minCellWidth: 30,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } }],
                        [
                            { content: EMPLOYEE_NO && '1' || '', styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: EMPLOYEE_NO || '', colSpan: 3, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: EmployeeName || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: POSITION || '', colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: vendorname || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },

                            { content: DEPARTMENT || '', colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            // { content: EMPLOYEETYPE || '', colSpan: 3, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content:  FROMDATE || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content:  TODATE || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: Month1 || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} },
                            { content: Years || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' , fontStyle:'bold'} }
                        ],

                        [
                                    //Blank  row
                                    {content: '',colSpan:34, styles: { lineColor: 'black',halign: 'center'}} ,
                                    // ...ViewList.map(el => ({ content: '', colSpan: 1, styles: { lineColor: 'black', halign: 'center' } })) ,
                                    // { content: '', colSpan:  daysInMonth === 31 ? 1 : 2, styles: { lineColor: 'black', halign: 'center' } },
                                    // ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))
                        ],
                         
                        [
                            { content: 'Date', colSpan: 2, styles: {textColor: 'black' , fontSize: 11, fontStyle: 'bold', lineColor: 'black', halign: 'center'  } },
                            ...ViewList.map(el => Object.assign({}, {content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', colSpan: 1, styles: { textColor: 'black', overflow: 'linebreak', lineColor: 'black', halign: 'center',fontStyle: 'bold'} })),
                            // ...ViewList.map(el => Object.assign({}, { content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', styles: {cellWidth: '15px', overflow: 'linebreak', lineColor: 'black', halign: 'center',fontSize: 6 ,  textColor: 'black'} })),
                            { content: 'Total', colSpan:  daysInMonth === 31 ? 1 : 2 , styles: {textColor: 'black' ,fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                            // { content: 'Pre-Approval', styles: { fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                            // ...Array(missingCols).fill({ content: '' ,colSpan: 1 , styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                            ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))

                        ],
                        [
                            { content: 'Shift', colSpan: 2, styles: {textColor: 'black' ,fontSize: 11, fontStyle: 'bold', lineColor: 'black', halign: 'center'  } },
                            ...ViewList.map(el => Object.assign({}, { content: el.ShiftName || '',colSpan: 1, styles: el.ShiftName && el.ShiftName.length > 5 ?  { textColor: 'black', lineColor: 'black', halign: 'center', fontSize: 8, fontStyle: 'bold'} : { textColor: 'black', lineColor: 'black', halign: 'center', fontStyle: 'bold' } })),
                            // ...ViewList.map(el => Object.assign({}, { content: el.ShiftName || '', styles: { minCellWidth: 6, lineColor: 'black', halign: 'center',fontSize: 6 ,  textColor: 'black'} })),
                            // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            { content: '', colSpan:  daysInMonth === 31 ? 1 : 2, styles: { textColor: 'black', lineColor: 'black', halign: 'center' } },
                            // ...Array(missingCols).fill({ content: '' ,colSpan: 1, styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                            ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))

                            
                        ],
                            // [
                            //     { content: 'Cost Center', colSpan: 2, styles: { fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                            //     ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', colSpan: 1, styles: el.costCenterNum && el.costCenterNum.length > 5 ?  { fontSize: 8, lineColor: 'black', halign: 'center', fontStyle: 'bold'} : { lineColor: 'black', halign: 'center' , fontStyle: 'bold' } })),
                            //     // ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', styles: { minCellWidth: 6, lineColor: 'black', halign: 'center',fontSize: 6 ,  textColor : 'black' } })),
                            //     // { content:  '', styles: { lineColor: 'black', halign: 'center' } },
                            //     // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            //     { content: '', colSpan:  daysInMonth === 31 ? 1 : 2, styles: { lineColor: 'black', halign: 'center' } },
                            // ...Array(missingCols).fill({ content: '' ,colSpan: 1, styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells

                            // ],

                            // [
                            //     { content: 'Present Hours', colSpan: 2, styles: {  textColor: 'black' ,fontSize: 11, fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                            //     ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours !== null && el.attendanceHours !== undefined ? Number(el.attendanceHours).toFixed(1).replace(/\.0+$/, '') : 0 ,colSpan: 1, styles: {textColor:'black', lineColor: 'black', halign: 'center', fontStyle: 'bold'  } })),
                            //     // ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours && el.attendanceHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', halign: 'center',fontSize: 6 ,  textColor: 'black'} })),
                            //     // ...Array(missingCols).fill({ content: '' , styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                            //     { content: attendanceHours && parseFloat(attendanceHours).toFixed(1) || 0 ,colSpan:  daysInMonth === 31 ? 1 : 2, styles: {textColor: 'black',   lineColor: 'black', halign: 'center' , fontStyle: 'bold' } },
                            //     // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            //     // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            //     // ...Array(missingCols).fill({ content: '' ,colSpan: 1, styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                            //     ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))
                                
                                
                                
                            // ], 
                            [
                                { content: 'Basic Hours', colSpan: 2, styles: { textColor: 'black' ,fontSize: 11,   fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                                ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || 0 , colSpan: 1, styles: { textColor: 'black', lineColor: 'black', halign: 'center',fontStyle :'bold'} })),
                                // ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || '', styles: { minCellWidth: 6, lineColor: 'black', halign: 'center',fontSize: 6 , textColor: 'black' } })),
                                // ...Array(missingCols).fill({ content: '' , styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                                { content: WorkingHours || 0,colSpan:  daysInMonth === 31 ? 1 : 2, styles: { textColor: 'black',   lineColor: 'black', halign: 'center' , fontStyle: 'bold'} },
                            // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            // { content: '', styles: { lineColor: 'black', halign: 'center' } },
                            // ...Array(missingCols).fill({ content: '' ,colSpan: 1, styles :{lineColor:'black',halign: 'center'}}) ,// Fill remaining columns with empty cells
                            ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))


                        ],
                            
                        [
                            { content: 'O/T Hours', colSpan: 2, styles: {textColor: 'black' , fontSize: 11, fontStyle:'bold', lineColor: 'black', halign: 'center' } },
                            ...ViewList.map(el => Object.assign({}, { content: el.OTHours !== null && el.OTHours !== undefined ? Number(el.OTHours).toFixed(1).replace(/\.0+$/, '') : 0 , colSpan: 1, styles: { textColor: 'black', lineColor: 'black', halign: 'center',fontStyle :'bold'} })),
                            { content: OTHours && parseFloat(OTHours).toFixed(1) || 0 , colSpan:  daysInMonth === 31 ? 1 : 2, styles: { textColor: 'black', lineColor: 'black', halign: 'center' , fontStyle: 'bold'  } },
                            // { content: otph && otph != null && !isNaN(parseFloat(otph)) && parseFloat(otph).toFixed(2) || '', styles: { lineColor: 'black', halign: 'center',  } },
                            // { content: '', styles: { lineColor: 'black', halign: 'center' } }
                            // ...ViewList.map(el => Object.assign({}, { content: el.OTHours && el.OTHours.toFixed(2) || '', styles: { minCellWidth: 6, lineColor: 'black', halign: 'center',fontSize: 6 ,  textColor: 'black'} })),
                            // { content: OTHours && parseFloat(OTHours).toFixed(2) || '', styles: { lineColor: 'black', halign: 'center',fontSize: 6  } },
                            // { content: otph && otph != null && otph.toFixed(2) || '', styles: { lineColor: 'black', halign: 'center',fontSize: 6  } },
                            // { content: '', styles: { lineColor: 'black', halign: 'center',fontSize: 6  } },
                            // ...Array(missingCols).fill({ content: '' ,colSpan: 1, styles :{lineColor:'black', halign: 'center'}}) ,// Fill remaining columns with empty cells
                            ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black',lineWidth: {top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))
                            
                            
                        ],
                        ...(() => {
                            const uniqueCostCenters = Array.from(new Set(ViewList.map(el => el.costCenterNum).filter(Boolean)));
                            return uniqueCostCenters.map(costCenter => {
                                const costCenterTotal = ViewList
                                    .filter(el => el.costCenterNum === costCenter)
                                    .reduce((sum, el) => sum + (el.attendanceHours !== null && el.attendanceHours !== undefined ? Number(el.attendanceHours) : 0), 0);
                                    
                                    const costCenterval = costCenter.toLowerCase().charAt(0).toUpperCase() + costCenter.toLowerCase().slice(1);
                                return [
                                    { content: ` ${costCenterval}`, colSpan: 2, styles: {  textColor: 'black' ,fontSize: 11 , fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                                    ...ViewList.map(el => Object.assign({}, { 
                                        content: el.costCenterNum === costCenter ? (el.attendanceHours !== null && el.attendanceHours !== undefined ? Number(el.attendanceHours).toFixed(1).replace(/\.0+$/, '') : '') : '',
                                        colSpan: 1, 
                                        styles: { textColor: 'black', lineColor: 'black', halign: 'center', fontStyle: 'bold' } 
                                    })),
                                    { content: costCenterTotal > 0 ? costCenterTotal.toFixed(1).replace(/\.0+$/, '') : 0, colSpan: daysInMonth === 31 ? 1 : 2, styles: { textColor: 'black', lineColor: 'black', halign: 'center', fontStyle: 'bold' } },
                                    ...Array.from({ length: missingCols }).map((_, idx) => ({ content: '', colSpan: 1, styles: { halign: 'center', lineColor: 'black', lineWidth: { top: 0.1, bottom: 0.1, left: idx === 0 ? 0.1 : 0, right: idx === missingCols - 2 ? 0.1 : 0 } } }))
                                ];
                            });
                        })(),                         
                        // ...existing code...
                                    // Separate table for Costcenters Worked
                                    //  [
                                        //     { content:  'Present Days:'+PresentDays != null && PresentDays != undefined? 'Present Days:'+PresentDays:'Present Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content:  'Absent Days:'+AbsentDays != null && AbsentDays  != undefined ? 'Absent Days:'+AbsentDays:'Absent Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content: 'Week Off Days:'+OffDays != null  && OffDays  != undefined ?'Week Off Days:'+ OffDays:'Week Off Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content: 'Present In Weekend:'+PresentInWe != null  && PresentInWe  != undefined ? 'Present In Weekend:'+PresentInWe:'Present In Weekend:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content: 'Present In Holiday:'+PresentInLH != null  && PresentInLH  != undefined  ? 'Present In Holiday:'+PresentInLH:'Present In Holiday:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content:  'Unpaid Leave:'+AbsentDaysUL != null  && AbsentDaysUL  != undefined  ? 'Unpaid Leave:'+AbsentDaysUL:'Unpaid Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content:  'Annual Leave:'+Vacationdays != null && Vacationdays  != undefined  ? 'Annual Leave:'+Vacationdays:'Annual Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content: 'Holidays:'+Holidays != null  && Holidays  != undefined ?  'Holidays:'+Holidays: 'Holidays:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                                        //     { content: 'Sick Leave:'+AbsentDaysSL != null  && AbsentDaysSL  != undefined ?'Sick Leave:'+ AbsentDaysSL:'Sick Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } }
                                        // ],
                                    ],
                                })

            
                    
            //     doc.autoTable({
            //     theme: 'grid',
            //     tableWidth: 'wrap',
            //     cellWidth: 'wrap',
            //     styles: { fontSize: 12.5 },

            //     body: [
            //         [
            //             {
            //                 content: (() => {
            //                     const costcenters = Array.from(new Set(
            //                         (ViewList || [])
            //                             .map(el => el.costCenterNum)
            //                             .filter(Boolean)
            //                             .map(c => c.trim())
            //                     ));
            //                     return 'Cost Center: ' + (costcenters.length > 0 ? costcenters.join(', ') : 'N/A');
            //                 })(),
            //                 // colSpan: 22, // Adjust to your table width
            //                 styles: { fontStyle: 'bold', lineColor: 'black', halign: 'left' , textColor: 'black'}
            //             }
            //         ]
            //     ]
            // });
                                
            if (attendanceRows.length > 0) {
                    doc.autoTable({
                        theme: 'grid',
                        tableWidth: 90,
                        margin: { left: 14 , bottom:18 },
                        styles: { fontSize: 12.5 },
                        body: attendanceRows
                    });
                }

            doc.autoTable({
                theme: 'plain',
                styles: { fontSize: 12.5 },
                body: [
                    [
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '6', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { textColor: 'black', fillColor: 'white' } }
                    ],
                    // [
                    //     { content: '.....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                    //     { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                    //     { content: '.....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' } },
                    //     { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                    //     { content: '....................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                    //     { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                    //     { content: '.........................................................', colSpan: '6', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white',fontStyle: 'bold' } },
                    //     { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                    //     { content: '.........................................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                    // ],
                    [
                        // { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        { content: '.........................................................', colSpan: '6', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white',fontStyle: 'bold' } },
                        { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        // { content: '.........................................................', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                    ],
                    // [
                        // { content: 'Entered By', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        // { content: 'Checked By: Direct Supervisor', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        // { content: 'Approved by: HR Department', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                    // ],
                    [
                        { content: 'Approved by:', colSpan: '22', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        // { content: '', colSpan: '2', styles: { lineColor: 'white', halign: 'center', textColor: 'black', fillColor: 'white' ,fontStyle: 'bold'} },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                        // { content: '', colSpan: '2', style: { lineColor: 'white', textColor: 'black', fillColor: 'white' } },
                    ],
                    [
                        { content: '...............................................................................................................................................................................................................................................................................................................................................................................................................................................', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ],
                    [
                        // { content: 'Remarks: HR Department role is to confirm all type of leaves are documented & Direct Supervisor rule is to confirm (CO,OT,OC) are documented. Owner: HR Department', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                        { content: 'Remarks: This is a system generated timesheet.No signature required.', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ],
                    [
                        { content: '...............................................................................................................................................................................................................................................................................................................................................................................................................................................', colSpan: '22', styles: { textColor: 'black', fillColor: 'white', halign: 'center' ,fontStyle: 'bold' } }
                    ]
                ]
            })
               doc.addPage();
            })






            doc.save('Timesheet.pdf');
            this.setState({ loading: false });

        } else {

            /* Below variables to show particular timesheet in modal */
            const selEmpId = expandedRows && Object.keys(expandedRows).reduce((a, el) => el, false);
                            const selEmpData = TableEmployeeList && TableEmployeeList.find(_ => _.EMPLOYEE_NO === selEmpId) || {};
                const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years, WorkingHours,attendanceHours,vendorname, OTHours, otph, LateInEarlyOutTotal,PresentDays,AbsentDays,OffDays,PresentInWe,PresentInLH,AbsentDaysUL,Vacationdays,Holidays,AbsentDaysSL } = selEmpData;
                const ViewList = TableViewList && TableViewList.length > 0 && TableViewList.filter(_ => parseInt(_.EmployeeId) === parseInt(selEmpId) || parseInt(_.EmployeeCode) === parseInt(selEmpId)) || [];
            var doc = new jsPDF('landscape', 'mm', [1600, 1100]);

            const { process } = this.state;
                    let fromDate = '';
                    let toDate = '';
                    if (process && process.length > 0) {
                        const stage0 = process.find(stage => stage.stageSequence === 0);
                        if (stage0 && stage0.stage_Field) {
                            const fromField = stage0.stage_Field.find(f => f.fieldDescription === 'From Date');
                            const toField = stage0.stage_Field.find(f => f.fieldDescription === 'To Date');
                            fromDate = fromField ? fromField.fieldValue : '';
                            toDate = toField ? toField.fieldValue : '';
                        }
                    }
                    //to calculate empty cols
                const daysInMonth = ViewList.length; // N
                const totalColumns = 34; // Must match your header
                const fixedCols = 2 + 1; // 2 for colSpan at start, 1 for 'Total' at end
                const missingCols = totalColumns - (fixedCols + daysInMonth);
                const attendanceRows = [
                    { label: 'Present Days', value: PresentDays },
                    { label: 'Absent Days', value: AbsentDays },
                    { label: 'Week Off Days', value: OffDays },
                    { label: 'Present In Weekend', value: PresentInWe },
                    { label: 'Present In Holidays', value: PresentInLH },
                    { label: 'Unpaid Leave', value: AbsentDaysUL },
                    { label: 'Annual Leave', value: Vacationdays },
                    { label: 'Holidays', value: Holidays },
                    { label: 'Sick Leave', value: AbsentDaysSL }
                ]
                .filter(row => row.value != null && row.value != undefined && Number(row.value) > 0) // ✅ Only rows with value > 0
                .map(row => ([
                    { 
                        content: `${row.label}: ${row.value}`, 
                        colSpan: 4, 
                        styles: { halign: 'left', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } 
                    }
                ]));

                const addHeader = () => {
                const pageWidth = doc.internal.pageSize.getWidth();
                const marginTop = 18;
                doc.setFontSize(18);
                doc.setFont('helvetica', 'bold');
                doc.text('Arabian Pipecoating Company Limited.', pageWidth / 2, marginTop + 5, { align: 'center' });
                doc.setFontSize(18);
                doc.setFont('helvetica', 'bold');
                doc.text('TimeSheet', pageWidth / 2, marginTop + 18, { align: 'center' });
            };

            // const logoImg = `data:image/png;base64,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` ; // Replace with your actual logo
            doc.addImage(apcologo, 'PNG', 10, 10, 40, 20); // x, y, width, height
            addHeader();
                // const dayCols = ViewList.length;
                // const totalCols = 2 + dayCols + 2;
                // const missingCols = 36 - totalCols;

            // doc.autoTable({
            //     theme: 'grid',
            //     body: [[{
            //         content: "TIME SHEET APPROVAL FORM",
            //         colSpan: 8,
            //         styles: { halign: 'center', fillColor: '#A1A1A1', lineColor: 'black', textColor: 'black' }
            //     }],
            //     [{
            //         content: 'AL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Annual Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'SKL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Sick Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'CO',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Compensatory OFF',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'UL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Unpaid Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'EL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Emergency Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WI',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Working Injury Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'EXL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Examination Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'ML',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Marraige Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'CL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Child Birth Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'DL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Death Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'HL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Hajj Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'BT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Business Trip',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],


            //     [{
            //         content: 'TR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Training',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'SL',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Sport Leave',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D081-MOR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning (06.00am - 06.00pm)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D081-SECOND-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning Second Shift Saudi(13.30PM - 10.00pm))',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'D081-MOR-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Morning Saudi (06.00am - 06.00pm)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'D083 -GEN',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'General ( 7.30 - 17.00 pm ) - Jubail Site Office',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'N081-NIGHT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Evening(6.00pm - 06.00 am)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'N081-NIGHT-SA',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Evening Saudi(6.00pm - 06.00 am)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'DOFF - MOR',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off -Morning Shift',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off-NIGHT',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'WE-Off- Night',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'RD',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Ramadan Day (6:00 AM to 6:00PM)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'RN',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Ramadan Night (6:00 PM to 6:00AM)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }],

            //     [{
            //         content: 'D084',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     },
            //     {
            //         content: 'Day Shift (Saturday - Half Day)',
            //         styles: { halign: 'center', minCellWidth: 5, fillColor: 'white', lineColor: 'black', textColor: 'black' }
            //     }]
            //     ]
            // });



            doc.autoTable({

                theme: 'grid',
                styles: { fontSize: 12 },
                // head: [
                //         [{ content: "SNo", styles: { halign: 'center', minCellWidth: 5, lineColor: 'black', textColor: 'black', fontStyle: 'bold',  fillColor: [255, 255, 255]  } },
                //         { content: "Emp No", styles: { halign: 'center', minCellWidth: 12, lineColor: 'black', textColor: 'black', fontStyle: 'bold',  fillColor: [255, 255, 255]  } },
                //         { content: "Name", colSpan: 8, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' , fillColor: [255, 255, 255]  } },
                //         { content: "Position", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' , fillColor: [255, 255, 255]  } },
                //         { content: "Company", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' ,  fillColor: [255, 255, 255] } },                           
                //         { content: "Department", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' , fillColor: [255, 255, 255] } },
                //         { content: "Employee Type", colSpan: 4, styles: { halign: 'center', minCellWidth: 30, lineColor: 'black', textColor: 'black', fontStyle: 'bold' , fillColor: [255, 255, 255]  } },
                //         { content: "Month", colSpan: 2, styles: { halign: 'center', minCellWidth: 20, lineColor: 'black', textColor: 'black', fontStyle: 'bold' ,  fillColor: [255, 255, 255] } },
                //         { content: "Year", colSpan: 2, styles: { halign: 'center', minCellWidth: 30, lineColor: 'black', textColor: 'black', fontStyle: 'bold' ,  fillColor: [255, 255, 255] } }],
                // ],
                body: [
                    [{ content: "SNo", styles: { halign: 'center', minCellWidth: 15 , lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Emp No",colSpan:2 , styles: { halign: 'center', minCellWidth: 12,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Name", colSpan: 6, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Position", colSpan: 6, styles: { halign: 'center',  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Company", colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },                           
                        { content: "Department", colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Employee Type", colSpan: 4, styles: { halign: 'center', minCellWidth: 20,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Month", colSpan: 2, styles: { halign: 'center', minCellWidth: 20, lineColor: 'black', textColor: 'black', fontStyle: 'bold' } },
                        { content: "Year", colSpan: 2, styles: { halign: 'center', minCellWidth: 30,  lineColor: 'black', textColor: 'black', fontStyle: 'bold' } }],
                        
                        [
                            { content: EMPLOYEE_NO && '1' || '', styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: EMPLOYEE_NO || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: EmployeeName || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: POSITION || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: vendorname || '', colSpan: 6, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },

                            { content: DEPARTMENT || '', colSpan: 5, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: EMPLOYEETYPE || '', colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: Month1 || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                            { content: Years || '', colSpan: 2, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } }
                        ],
                       
                    [
                        { content: '', colSpan: '2', styles: { lineColor: 'black' } },
                        ...ViewList.map(el => Object.assign({}, { content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', styles: { cellWidth: 10, fontStyle: 'bold', lineColor: 'black', halign: 'center',} })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.ShiftDate && moment(el.ShiftDate).format('DD') || '', styles: { cellWidth: 10, fontStyle: 'bold', lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content: 'Total', styles: { fontStyle: 'bold', lineColor: 'black' } },
                        // { content: 'Pre-Approval', styles: { fontStyle: 'bold', lineColor: 'black' } },
                        // ...Array(missingCols).fill({ content: '' , styles:{lineColor: 'black'}}) // Fill remaining columns with empty cells

                    ],
                    [
                        { content: 'Shift', colSpan: '2', styles: { fontStyle: 'bold', lineColor: 'black' } },
                        // { content: 'Shift', colSpan: '2', styles: { textColor: 'white', lineColor: 'black' } },
                        ...ViewList.map(el => Object.assign({}, { content: el.ShiftName || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center' , fontStyle: 'bold'} })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.ShiftName || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content: '', styles: { lineColor: 'black' } },
                        { content: '', styles: { lineColor: 'black' } },
                        { content: '', styles: { lineColor: 'black' } }

                    ],
                    [
                        { content: 'Cost Center', colSpan: '2', styles: { fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                        ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontStyle: 'bold'} })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.costCenterNum && el.costCenterNum|| '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content:  '', styles: { lineColor: 'black', halign: 'center' } },
                        { content: '', styles: { lineColor: 'black', halign: 'center' } },
                        { content: '', styles: { lineColor: 'black', halign: 'center' } }
                    ],
                    [
                        { content: 'Attendance Hours', colSpan: '2', styles: { fontStyle: 'bold', lineColor: 'black', halign: 'center' } },
                        ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours !== null && el.attendanceHours !== undefined ? Number(el.attendanceHours).toFixed(2).replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1') : '', styles: { textColor: 'black', cellWidth: 10, lineColor: 'black', halign: 'center', fontStyle: 'bold' } })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.attendanceHours && el.attendanceHours.toFixed(2) || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content: attendanceHours && parseFloat(attendanceHours).toFixed(2) || '', styles: { textColor: 'black',lineColor: 'black', halign: 'center', fontStyle: 'bold' } },
                        { content: '', styles: { lineColor: 'black', halign: 'center' } },
                        { content: '', styles: { lineColor: 'black', halign: 'center' } }
                    ],                       
                    [
                        { content: 'Regular Hours', colSpan: '2', styles: { fontStyle: 'bold', lineColor: 'black' } },
                        ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center', fontStyle: 'bold'} })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.WorkingHours || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content: WorkingHours || '', styles: { lineColor: 'black', fontStyle: 'bold' } },
                        { content: '', styles: { lineColor: 'black', fontStyle: 'bold' } },
                        { content: '', styles: { lineColor: 'black', fontStyle: 'bold' } }
                    ],

                    [
                        { content: 'OT', colSpan: '2', styles: {  fontStyle: 'bold',lineColor: 'black' } },
                            ...ViewList.map(el => Object.assign({}, { content: el.OTHours !== null && el.OTHours !== undefined ? Number(el.OTHours).toFixed(1).replace(/\.0+$/, '') : 0, colSpan: 1, styles: {  lineColor: 'black', halign: 'center',fontStyle :'bold'} })),
                        // ...ViewList.map(el => Object.assign({}, { content: el.OTHours && el.OTHours.toFixed(2) || '', styles: { cellWidth: 10, lineColor: 'black', halign: 'center',fontSize: 6  } })),
                        { content: OTHours &&  parseFloat(OTHours).toFixed(2) || '', styles: { lineColor: 'black' , fontStyle: 'bold'} },
                        // { content: otph && otph != null && otph.toFixed(2) || '', styles: { lineColor: 'black', halign: 'center' } },
                        { content: '', styles: { lineColor: 'black', fontStyle: 'bold' } }
                    ],
                    //    [
                    //         { content:  'Present Days:'+PresentDays != null && PresentDays != undefined? 'Present Days:'+PresentDays:'Present Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content:  'Absent Days:'+AbsentDays != null && AbsentDays  != undefined ? 'Absent Days:'+AbsentDays:'Absent Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content: 'Week Off Days:'+OffDays != null  && OffDays  != undefined ?'Week Off Days:'+ OffDays:'Week Off Days:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content: 'Present In Weekend:'+PresentInWe != null  && PresentInWe  != undefined ? 'Present In Weekend:'+PresentInWe:'Present In Weekend:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content: 'Present In Holiday:'+PresentInLH != null  && PresentInLH  != undefined  ? 'Present In Holiday:'+PresentInLH:'Present In Holiday:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content:  'Unpaid Leave:'+AbsentDaysUL != null  && AbsentDaysUL  != undefined  ? 'Unpaid Leave:'+AbsentDaysUL:'Unpaid Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content:  'Annual Leave:'+Vacationdays != null && Vacationdays  != undefined  ? 'Annual Leave:'+Vacationdays:'Annual Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content: 'Holidays:'+Holidays != null  && Holidays  != undefined ?  'Holidays:'+Holidays: 'Holidays:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } },
                    //         { content: 'Sick Leave:'+AbsentDaysSL != null  && AbsentDaysSL  != undefined ?'Sick Leave:'+ AbsentDaysSL:'Sick Leave:'+0, colSpan: 4, styles: { halign: 'center', lineColor: 'black', textColor: 'black' } }

                    //     ]
                ],
              
            })
            if (attendanceRows.length > 0) {
                    doc.autoTable({
                        theme: 'grid',
                        tableWidth: 75,
                        margin: { left: 14 },
                        styles: { fontSize: 12 },
                        body: attendanceRows
                    });
                }



            doc.save('Timesheet.pdf');
        }

    }

    render() {
        const { tableLists, location = {}, employeeWorkSheetData = {}, keywordValuesList = [],keywordValuesListsup= [] } = this.props;
        const { state = {} } = location;
        const { process, expandedRows, stageSequence, employeeData = [] } = this.state;

        const { Table: EmployeeList = [], Table1 = [] } = employeeWorkSheetData;
        const pendingWith = location && location.state && location.state.pendingWith;

        const requestFrom = location && location.state && location.state.requestFrom;
        const status = (state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;

        const TableViewList = (pageType === 'edit' && tableLists && Object.keys(tableLists).length > 0 && tableLists.requestTimeSheet && tableLists.requestTimeSheet.length > 0) ? tableLists.requestTimeSheet.map(el => Object.assign({}, {
            EarlyInHours: el.earlyInHours,
            EarlyOutHours: el.earlyOutHours,
            EmpInTime: el.empInTime,
            EmpOutTime: el.empOutTime,
            EmployeeCode: el.employeeCode,
            EmployeeId: el.employeeId,
            EmployeeName: el.employeeName,
            LateInHours: el.lateInHours,
            LateOutHours: el.lateOutHours,
            OtendTime: el.otendTime,
            Othours: el.othours,
            OtstartTime: el.otstartTime,
            ReportedBy: el.reportedBy,
            RequestId: el.requestId,
            ShiftDate: el.shiftDate,
            ShiftEndTime: el.shiftEndTime,
            ShiftName: el.shiftName,
            costCenterNum: el.costCenterNum,
            attendanceHours: el.attendanceHours,
            ShiftStartTime: el.shiftStartTime,
            TimeSheetId: el.timeSheetId,
            WorkingHours: el.workingHours,
            FirstInDateTime: el.firstindatetime,
            LastOutDateTime: el.firstindatetime
        })) : Table1.map(el => Object.assign({}, { ...el }, { EmployeeId: keywordValuesList.filter(_ => _.id === el.EmployeeCode).reduce((a, el) => el.uniqueId, false) }));

        const Tableheader = (pageType === 'edit' && tableLists && Object.keys(tableLists).length > 0)? tableLists.timesheetheaders.map(el => Object.assign({}, {
            EMPLOYEE_NO: el.employeeNo,
            EmployeeName: el.employeeName,
            POSITION: el.position,
            DEPARTMENT: el.department,
            EMPLOYEETYPE: el.employeetype,
            Years: el.years,
            email: el.email,
            vendor: el.vendor,
            vendormail: el.vendormail,
            vendorname: el.userdefinedfield1,
            OTHours: el.othours,
            otph: el.otph,
            attendanceHours: el.attendanceHours,
            WorkingHours: el.requestId,
            attendanceHoursold: el.shiftDate,
            LateInHours: el.shiftEndTime,
            EarlyOutHours: el.shiftName,
            LateInEarlyOutTotal: el.costCenterNum,
            Month1: el.month1,
            attendanceHours12: el.sickleave,
            PresentDays: el.presentdays,
            AbsentDays: el.abscentdays,
            OffDays: el.offdaysweekends,
            PresentInWe: el.presentinwe,
            PresentInLH: el.presentinholiday,
            AbsentDaysUL: el.unpaidleave,
            Vacationdays: el.annualleave,
            Holidays: el.holidays,
            AbsentDaysSL:el.sickleave,
        })):EmployeeList;

        //const TableEmployeeList = (pageType === 'edit') ? employeeData.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
        const TableEmployeeList = (pageType === 'edit') ? Tableheader.filter(_ => TableViewList.map(el => el.EmployeeCode).includes(_.EMPLOYEE_NO)) : EmployeeList;
        const selEmployees = expandedRows && Object.keys(expandedRows).reduce((a, el) => {
            a.push(Object.assign({}, { EMPLOYEE_NO: el }));
            return a;
        }, []) || TableEmployeeList;

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );

        const header = (
            <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <ReactHTMLTableToExcel
                        className="p-button p-component p-button-secondary"
                        table="table-to-xls"
                        filename="Timesheet"
                        sheet="Timesheet"
                        buttonText={<div><span className="pi pi-download p-c p-button-icon-left" />Export Excel</div>} />
                    <Button onClick={() => this.downloadPDF('all')} label="Export PDF" icon="pi pi-download" className="p-button-secondary ml1" />
                </div>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );


        const ref = React.createRef();

        const EmployeeComponent = ({ style }) => (<div className="p-grid" style={style}>
            <div className="mt2">
                {/* <ReactHTMLTableToExcel
                    className="p-button p-component p-button-secondary table-xls-button"
                    table="table-to-xls"
                    filename="Timesheet"
                    sheet="Timesheet"
                    style={{ marginBottom: '10px' }}
                    buttonText={<div><span className="pi pi-download p-c p-button-icon-left" />Export Excel</div>} />
                <Button onClick={this.downloadPDF.bind(this)} label="Export PDF" icon="pi pi-download" className="p-button-secondary ml1" style={{ marginBottom: '10px' }} /> */}
                <TableContainer component={Paper}>
                    <Table aria-label="spanning table" id="table-to-xls" ref={ref}>
                        <TableHead className="timesheetHeader" style={{ display: 'none' }}>
                            <TableRow style={{ backgroundColor: '#bebcbc' }}>
                                <TableCell align="center" colSpan="36">TIME SHEET APPROVAL FORM</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="timesheetBody" style={{ display: 'none' }}>
                            {this.state.timesheetForm.map((sheet, index) =>
                                <TableRow key={index}>
                                    {sheet.map((c, x) =>
                                        <TableCell key={x} align="center" colSpan={x % 2 === 0 ? "2" : "7"} style={{ textAlign: 'center' }}>{c}</TableCell>
                                    )}
                                </TableRow>
                            )}
                            <TableRow>
                                <TableCell align="center" colSpan="36"></TableCell>
                            </TableRow>
                        </TableBody>
                        {selEmployees.map((list, index) => {

                            const selEmpData = TableEmployeeList && TableEmployeeList.find(_ => _.EMPLOYEE_NO === list.EMPLOYEE_NO) || {};
                            const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years, WorkingHours,attendanceHours,vendorname, OTHours, otph, LateInEarlyOutTotal,PresentDays,AbsentDays,OffDays,PresentInWe,PresentInLH,AbsentDaysUL,Vacationdays,Holidays,AbsentDaysSL } = selEmpData;
                            const ViewList = TableViewList.filter(_ => parseInt(_.EmployeeId) === parseInt(list.EMPLOYEE_NO) || parseInt(_.EmployeeCode) === parseInt(list.EMPLOYEE_NO));

                            return (<Table>
                                <TableHead className="timesheetHeader">
                                    <TableRow rowSpan= "2" style={{ backgroundColor: '#bebcbc',  fontWeight: 'bold', fontSize: "18px", border: "solid 1px black" }}>
                                        <TableCell align="center">SNo</TableCell>
                                        <TableCell align="center">Emp No</TableCell>
                                        <TableCell align="center" colSpan="4">Name</TableCell>
                                        <TableCell align="center" colspan="4">Position</TableCell>
                                        <TableCell align="center" colspan="4">Company</TableCell>
                                        <TableCell align="center" colSpan="6">Department</TableCell>
                                        <TableCell align="center" colSpan="4">Employee Type</TableCell>
                                        <TableCell align="center" colSpan="6">Month</TableCell>
                                        <TableCell align="center" colSpan="6">Year</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="timesheetBody">
                                    <TableRow style={{ backgroundColor: '#eb9c4d', border: "solid 1px black" }}>
                                        <TableCell align="center" style={{ textAlign:"center"}}>{EMPLOYEE_NO && '1' || null}</TableCell>
                                        <TableCell align="center" style={{ textAlign:"center"}}>{EMPLOYEE_NO}</TableCell>
                                        <TableCell align="center" colSpan="4" style={{ textAlign:"center"}}>{EmployeeName}</TableCell>
                                        <TableCell align="center" colSpan="4" style={{ textAlign: "center" }}>{POSITION}</TableCell>
                                        <TableCell align="center" colSpan="4" style={{ textAlign:"center"}}>{vendorname}</TableCell>
                                        <TableCell align="center" colSpan="6" style={{ textAlign:"center"}}>{DEPARTMENT}</TableCell>
                                        <TableCell align="center" colSpan="4" style={{ textAlign:"center"}}>{EMPLOYEETYPE}</TableCell>
                                        <TableCell align="center" colSpan="6" style={{ textAlign:"center"}}>{Month1}</TableCell>
                                        <TableCell align="center" colSpan="6" style={{ textAlign:"center"}}>{Years}</TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableHead className="timesheetHeader">
                                    <TableRow style={{ backgroundColor: '#a1a1a1', border: "solid 1px black" }}>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px green" }}align="center" colSpan="4">Present Days:{PresentDays }</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px red" }} align="center" colSpan="4">Absent Days:{AbsentDays}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px orange" }}align="center" colSpan="4">OffDays -WeekEnds:{OffDays}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px green" }}align="center" colSpan="4">Present in WE:{PresentInWe}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px green" }}align="center" colSpan="4">Present In Holiday:{PresentInLH}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px blue" }}align="center" colSpan="4">Un Paid Leave:{AbsentDaysUL}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px blue" }}align="center" colSpan="4">Vacation Days:{Vacationdays}</TableCell>
                                        <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px green" }} align="center" colSpan="4">Holidays:{Holidays}</TableCell>   
                                         <TableCell style={{ backgroundColor: '#a1a1a1', border: "solid 1px green" }}align="center" colSpan="4">Sick Leave:{AbsentDaysSL}</TableCell>  
                                    </TableRow>
                                </TableHead>
                                <TableHead className="timesheetHeader">
                                    <TableRow style={{ backgroundColor: '#cac9c9' }}>
                                        <TableCell colSpan="2">&nbsp;</TableCell>
                                        {ViewList.map((el, index) => <TableCell key={index} align="center">{el.ShiftDate && moment(el.ShiftDate).format('DD') || null}</TableCell>)}
                                        <TableCell align="center">Total</TableCell>
                                        <TableCell align="center">Pre-Approval</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="timesheetBody1">
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'darkblue', color: '#fff', textAlign:"center", border: "solid 1px black", fontSize: "14px"}}>FirstIn-LastOut</TableCell>
                                      {ViewList.map((fe, index) => {  const firstIn = fe.FirstInDateTime ? new Date(fe.FirstInDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit',hour12: false }) : '';
                                                                      const lastOut = fe.LastOutDateTime ? new Date(fe.LastOutDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit',hour12: false }) : '';

                                        return (
                                            <TableCell style={{ textAlign: "center" }} key={index} align="center">
                                            {firstIn + ' - ' + lastOut}
                                            </TableCell>
                                        );
                                        })}                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                       
                                    </TableRow>                                    
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'darkblue', color: '#fff', textAlign:"center", border: "solid 1px black", fontSize: "14px"}}>Shift</TableCell>
                                        {ViewList.map((fe, index) => <TableCell style={{ textAlign:"center" }} key={index} align="center">{fe.ShiftName}</TableCell>)}
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                   
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'orange', color: '#fff', textAlign:"center", border: "solid 1px black", fontSize: "14px"}}>Cost Center</TableCell>
                                        {ViewList.map((fe, index) => <TableCell style={{ textAlign:"center" }} key={index} align="center">{fe.costCenterNum}</TableCell>)}
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                      
                                    </TableRow>      
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'green', color: '#fff', textAlign:"center", border: "solid 1px black", fontSize: "14px"}}>Attendance Hours</TableCell>
                                        {ViewList.map((fe, index) => <TableCell style={{ textAlign:"center" }} key={index} align="center">{fe.attendanceHours}</TableCell>)}
                                        <TableCell align="center">{attendanceHours}</TableCell>
                                        <TableCell align="center"></TableCell>
                                  
                                    </TableRow>                                       
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ fontWeight: 'bold', textAlign:"center", border: "solid 1px black", fontSize: "14px"}}>Regular Hours</TableCell>
                                        {ViewList.map((se, index) => <TableCell key={index} style={{ textAlign:"center"}} align="center">{se.WorkingHours}</TableCell>)}
                                        <TableCell align="center">{WorkingHours || ''}</TableCell>
                                        <TableCell align="center"></TableCell>
                                  
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'red', fontWeight: 'bold', color: '#fff', textAlign:"center" , border: "solid 1px black", fontSize: "14px"}}>OT</TableCell>
                                        {ViewList.map((fe, index) => <TableCell key={index} style={{ textAlign:"center", borderBottom: "solid 1px black"}} align="center">
                                        {/* {fe.Othours && fe.Othours.toFixed(2) || ''}</TableCell>)} */}
                                         {(pageType === 'edit' ? fe.Othours : fe.OTHours) != null && !isNaN(parseFloat(pageType === 'edit' ? fe.Othours : fe.OTHours)) ? parseFloat(pageType === 'edit' ? fe.Othours : fe.OTHours).toFixed(2) : ''}</TableCell>)}
                                        <TableCell align="center"style={{ textAlign:"center", borderBottom: "solid 1px black"}}>{OTHours}</TableCell>
                                        {/* <TableCell align="center"style={{ textAlign:"center", borderBottom: "solid 1px black"}}>{otph && otph != null &&otph != undefined && otph!="9" && otph != 9 && typeof(otph) === "number" && otph.toFixed(2)}</TableCell> */}
                                        <TableCell align="center"style={{ textAlign:"center", borderBottom: "solid 1px black"}}>    {otph && otph != null && otph != undefined && !isNaN(parseFloat(otph)) && parseFloat(otph).toFixed(2)}</TableCell>

                                   
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="54" style={{ border: 'none' }} ></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>)
                        })}
                        <Table>
                            <TableHead className="timesheetHeader" style={{ display: 'none' }}>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="36" style={{ border: 'none' }} ></TableCell>
                                </TableRow>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="36" style={{ border: 'none' }} ></TableCell>
                                </TableRow>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none', borderTop: '1px dotted black', textAlign: 'center' }} >Supervisor / Dept SI</TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none', borderTop: '1px dotted black', textAlign: 'center' }}>Dept. Manager</TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none', borderTop: '1px dotted black', textAlign: 'center' }}>Director/Division Chief</TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="6" style={{ border: 'none', borderTop: '1px dotted black', textAlign: 'center' }}>HR Emp Relation Specialist/C&B</TableCell>
                                    <TableCell align="center" colSpan="2" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none', borderTop: '1px dotted black', textAlign: 'center' }}>HR Operation Manager</TableCell>
                                </TableRow>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="36" style={{ border: 'none' }} ></TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                        <Table>
                            <TableHead className="timesheetHeader" style={{ display: 'none' }}>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="36" style={{ border: 'none' }} ></TableCell>
                                </TableRow>
                                <TableRow style={{ backgroundColor: '#fff', borderTop: '1px solid black', borderBottom: '1px dotted black' }}>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }} ></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="16" style={{ border: 'none', textAlign: 'center' }}>Remarks: Employee relation role is to confirm all type of leaves are documented & Compensation role is to confirm (CO,OT,OC) are documented. Owner: HR Department - </TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                    <TableCell align="center" colSpan="4" style={{ border: 'none' }}></TableCell>
                                </TableRow>
                                <TableRow style={{ backgroundColor: '#fff' }}>
                                    <TableCell align="center" colSpan="36" style={{ border: 'none' }} ></TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </Table>
                </TableContainer>
            </div>
        </div>
        )
        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            TimeSheet
                            <Link to={'/timesheet'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    return field.fieldDescription === 'Run Time Evaluation' && stageIndex === 0 &&
                                        <div key={fieldIndex} className="p-col-12">
                                            <div className="p-col-12" style={{ display: 'flex' }}>
                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} onClick={this.getfilteredEmployeeList} style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} className="p-button-info" label="Get Employee" icon="pi pi-users" />
                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} onClick={this.clearEmployeeFilter} style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} className="p-button-warning" label="Clear Filter" icon="pi pi-times" />
                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} onClick={this.simulateOnClick.bind(this)} style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} className="p-button-secondary" label="Generate Data" icon="pi pi-upload" />
                                                <Inputs
                                                    field={field}
                                                    value={field.fieldValue}
                                                    process={process}
                                                    onInputChange={(e) => this.handleChange(e, field)}
                                                    enablePastDate={true}
                                                    {...this.props}
                                                    {...this.state}
                                                    style={{ marginTop: '6px', marginLeft: '20px' }} />
                                            </div>
                                            <DataTable ref={(el) => this.dt = el} responsive value={TableEmployeeList} paginator={true} rows={50} header={header}
                                                globalFilter={this.state.globalFilter}
                                                emptyMessage="No records found"
                                                className="mt3"
                                                expandedRows={this.state.expandedRows}
                                                onRowToggle={(e) =>  this.setState({ dynamicTimesheetDsplay: true, expandedRows: e.data })}
                                                rowExpansionTemplate={this.rowExpansionTemplate.bind(this)}
                                                dataKey="EMPLOYEE_NO">
                                                <Column expander={true} style={{ width: '3em' }} />
                                                <Column field="EMPLOYEE_NO" header="Employee Code" />
                                                <Column field="EmployeeName" header="Employee Name" />
                                                <Column field="POSITION" header="Employee Position" />
                                                <Column field="DEPARTMENT" header="Department" />
                                                <Column field="Month1" header="Shift Month" />
                                                <Column field="Years" header="Shift Year" />
                                            </DataTable>
                                        </div> || <div key={fieldIndex} className={field.fieldType === '6' ? "p-col-12 p-md-12 p-lg-12" : "p-col-12 p-md-4 p-lg-3"}>
                                            <Inputs
                                                field={field}
                                                value={field.fieldType === "3" && field.fieldValue ? field.fieldValue.split(',') : field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                enablePastDate={true}
                                                {...this.props}
                                                {...this.state} />
                                        </div>

                                })}


                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                       <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-secondary ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/timesheet'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || ( pendingWith !== null && status && status === 'Closed') ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || ( pendingWith !== null && status && status === 'Closed') ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/timesheet'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}

                            </div>
                        </div>
                    </div>
                })}

                {!this.state.dynamicTimesheetDsplay ? <EmployeeComponent style={{ display: 'none' }} /> : null}
                <Dialog header="View Timesheet" className="timesheetModal" visible={this.state.dynamicTimesheetDsplay} modal={true} onHide={() => this.setState({ dynamicTimesheetDsplay: false, expandedRows: false })}>
                    <EmployeeComponent />
                </Dialog>

                <Dialog header="Select Supervisor" visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">Select Next Approver<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder="Select Supervisor" name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = state => {
    const emplist = state?.master?.keywordValuesList?.map(e => ({ ...e, value: e.id })) || [];

//    this.setState( { emplist: emplist } )
    const subordinatesList = ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const keywordValuesListsup = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { label: el.label, value: el.uniqueId.toString() }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName} (Self) - ${state.auth.userObject.userID}`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]); 
    
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { label: el.label, value: el.id.toString() }));
        }
        return a;

    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName} (Self) - ${state.auth.userObject.userID}`, value: state.auth.userObject.userID, id: parseInt(state.auth.userObject.userID) })]);
    return {
        
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        keywordValuesList,
        keywordValuesListsup,
        employeeWorkSheetData: state.master.employeeWorkSheetData,
        metaData: Object.assign({}, {
            'Employee': emplist,
            'Division': state.master.employeeDivisionData,
             'Cost Center': state.keyword.CostCenter,
            'Project': state.keyword.PROJECT,
            'Vendor': state.keyword.Vendor,
           // 'Employees':state.keyword.Employee,
           'Employee Type': state.keyword.EMPLOYEETYPE,
            'Employee Sub Group': state.keyword.employeesubgroup,
            'Nationality': state.keyword.nationality,
            'Employee Status': state.keyword.EmployeeStatus, 
            'Employee Id':emplist,// state.keyword.Employee,
            'Organization Unit': state.keyword.OrgUnit,
        }),
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data)),
        getEmployeeDivisionData: (data) => dispatch(actions.getEmployeeDivisionData(data)),
        getEmployeeWorkSheetData: (data) => dispatch(actions.getEmployeeWorkSheetData(data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddTimesheetProcess);